"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = void 0;
exports.config = {
    skey: SKEY,
    apiKey: APIKEY,
    frontendSitesHost: FRONTHOST_SITES,
    context: {
        defaultCountryCode: "ES",
        domainId: DOMAINID,
        regionAutocomplete: "es"
    }
};
